module.exports = __webpack_public_path__ + "img/the-shadow-of-the-gods.70d364db.png";